import { Component, OnInit, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent
} from "@angular/material/dialog";
import { HttpErrorResponse } from "@angular/common/http";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../dialog-header/dialog-header.component";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-service-error-popup",
  templateUrl: "./service-error-popup.component.html",
  styleUrls: ["./service-error-popup.component.css"],
  imports: [
    MatDialogActions,
    MatButton,
    MatDialogClose,
    DialogHeaderComponent,
    MatDialogContent
  ]
})
export class ServiceErrorPopupComponent implements OnInit {
  data = inject<{
    title?: string;
    error: any;
  }>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<ServiceErrorPopupComponent>>(MatDialogRef);

  errorMessage: string;
  title = "Error";

  causes: string[] = [];

  extractCauseMessage(error: any) {
    console.log("recursive cause extract", error);

    //check if the type of error is HttpErrorResponse, and extract the message
    if (error instanceof HttpErrorResponse) {
      this.causes.push(error.message);
      return;
    }

    if (error && error.exceptionReason) {
      this.causes.push(error.exceptionReason.error.message);
      return;
    }

    //check if the error has a cause, and extract the message

    if (error && error.cause) {
      this.causes.push(error.cause.message);
      this.extractCauseMessage(error.cause);
    }
    if (error.length) {
      console.log("Extracted string error message", error);
      this.errorMessage = error as string;
    }
  }

  ngOnInit() {
    console.log("Opening dialog for ", this.data);
    this.title = this.data.title ?? "Error";

    if (typeof this.data.error === "string") {
      this.errorMessage = this.data.error;
    } else if (this.data.error && this.data.error.error) {
      this.errorMessage = this.data.error.error.message;
      this.extractCauseMessage(this.data.error.error);
    } else if (this.data.error) {
      this.errorMessage = this.data.error.message;
      this.extractCauseMessage(this.data.error);
    } else {
      this.errorMessage = this.data.error;
    }
    if (
      this.errorMessage &&
      (this.errorMessage.indexOf("StaleObjectStateException") > -1 ||
        this.errorMessage.indexOf("Optimistic") > -1)
    ) {
      this.errorMessage =
        "A record you are trying to update has been modified by another user or a system process. Please check the current values and try again.";
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
